import type { HttpMock } from '#e2e-utils/mockScenarios';

export const userUnavailableMocks: HttpMock[] = [
  {
    request: {
      method: 'GET',
      urlPathPattern: '^/userManagement/v2/internalUsers$',
    },
    response: {
      status: 204,
      body: undefined,
    },
  },
];
